import Vue from 'vue'

const { VUE_APP_API_HOST } = process.env
const STORAGE_PREFIX = 'overview/widgets/'
const MAX_ENTRIES = 30
const MAX_AGE = 7 * 24 * 3600 * 1000

// Requêtes identiques en cours partagées entre widgets (même métrique sur plusieurs cartes, etc.)
const inflight = new Map()

const storageKey = () => {
  try {
    const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
    return `${STORAGE_PREFIX}${(user && user.id) || 'anonymous'}`
  } catch (e) {
    return `${STORAGE_PREFIX}anonymous`
  }
}

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(storageKey()) || '{}') || {}
  } catch (e) {
    return {}
  }
}

// Garde les MAX_ENTRIES réponses les plus récentes ; quota dépassé = cache vidé plutôt que bloquant
function writeStore(path, data) {
  const store = { ...readStore(), [path]: { at: Date.now(), data } }
  const kept = Object.entries(store).sort((a, b) => b[1].at - a[1].at).slice(0, MAX_ENTRIES)
  try {
    localStorage.setItem(storageKey(), JSON.stringify(Object.fromEntries(kept)))
  } catch (e) {
    try { localStorage.removeItem(storageKey()) } catch (err) { /* indisponible */ }
  }
}

export function rangeParams({ since, until }, extra = {}) {
  const params = new URLSearchParams()
  if (since !== null && since !== undefined) {
    params.set('since', since)
    params.set('until', until)
  }
  params.set('timezone', new Date().getTimezoneOffset())
  Object.entries(extra).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '' && !(Array.isArray(v) && !v.length)) params.set(k, Array.isArray(v) ? v.join(',') : v)
  })
  return params.toString()
}

/**
 * GET sur l'API ; avec persist, le dernier résultat est gardé en cache local (affiché au prochain chargement, puis rafraîchi)
 * @param {string} path - ex. /reporting/metrics?...
 */
export function apiGet(path, { refresh = false, persist = true } = {}) {
  const url = `${VUE_APP_API_HOST}${path}${refresh ? '&refresh=1' : ''}`
  if (inflight.has(url)) return inflight.get(url)
  const promise = Vue.http.get(url, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
    .then(res => {
      if (persist) writeStore(path, res.body)
      return res.body
    })
    .finally(() => inflight.delete(url))
  inflight.set(url, promise)
  return promise
}

export function cachedGet(path) {
  const entry = readStore()[path]
  return entry && Date.now() - entry.at < MAX_AGE ? entry.data : null
}

// Valeur abrégée (k, M) comme les tuiles de l'overview
export function compact(value, percent = false) {
  if (value === null || value === undefined || isNaN(value)) return '—'
  if (percent) return `${Number(value).toFixed(1)}%`
  const abs = Math.abs(value)
  if (abs >= 1000000) return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
  if (abs >= 10000) return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'k'
  return Math.round(value).toLocaleString()
}

export const PALETTE = ['#6B1F4D', '#B64985', '#AB6E93', '#E0A3C4', '#8C5A7A', '#D3B6C6', '#4E1638', '#C98BAF']
